import * as React from 'react';
import { NavigationContext } from './NavigationContext';
/** Hook to access the [[NavigationContext]]. */
export function useNavigation() {
    var context = React.useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}
//# sourceMappingURL=useNavigation.js.map